export enum KeyboardKeys {
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ENTER = 'Enter',
  SPACE = 'Space',
  ESC = 'Escape',
  TAB = 'Tab',
}
